import React from "react";
import { Sparkles, ShieldCheck, Coins } from "lucide-react";

const trustItems = [
  { icon: Coins, label: "Bis zu 42 € / Monat" },
  { icon: ShieldCheck, label: "Von der Pflegekasse" },
  { icon: Sparkles, label: "100 % kostenfrei" },
];

export const Hero = () => {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100vh] flex items-center justify-center overflow-hidden bg-gradient-to-b from-[#F4F1EB] via-[#FAFAF7] to-[#E8F5EC]"
    >
      {/* Decorative blurred blobs */}
      <div className="absolute -top-40 -left-40 h-[480px] w-[480px] rounded-full bg-[#3FA66D]/15 blur-3xl" />
      <div className="absolute -bottom-32 -right-40 h-[520px] w-[520px] rounded-full bg-[#F4D8B5]/40 blur-3xl" />
      <div className="absolute top-1/3 right-1/4 h-[300px] w-[300px] rounded-full bg-[#A8E4BD]/30 blur-3xl" />

      {/* Subtle grid */}
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage:
            "linear-gradient(#1A1A1F 1px, transparent 1px), linear-gradient(90deg, #1A1A1F 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 sm:px-8 text-center pt-28 pb-24">
        <div
          data-testid="hero-eyebrow"
          className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full glass text-xs font-medium tracking-wider uppercase text-[#1A1A1F]/75 mb-8"
        >
          <span className="h-1.5 w-1.5 rounded-full bg-[#3FA66D] shadow-[0_0_10px_#3FA66D]" />
          pflege-box-gratis.de
        </div>

        <h1
          data-testid="hero-headline"
          className="text-5xl sm:text-6xl lg:text-7xl font-medium leading-[1.05] tracking-tight text-[#1A1A1F]"
        >
          Die <span className="text-gradient-green">Pflegebox</span>.
          <br className="hidden sm:block" />
          Monatlich. <span className="text-gradient-dark">Komplett gratis.</span>
        </h1>

        <p
          data-testid="hero-subtitle"
          className="mt-6 max-w-2xl mx-auto text-base sm:text-lg text-[#5A5F66] leading-relaxed"
        >
          Pflegehilfsmittel im Wert von bis zu 42&nbsp;€ – jeden Monat
          versandkostenfrei zu Ihnen nach Hause. Vollständig finanziert von Ihrer
          Pflegekasse.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            data-testid="hero-cta-primary"
            onClick={() => scrollTo("#kontakt")}
            className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-[#3FA66D] text-white font-semibold text-base hover:bg-[#368F5E] transition-transform hover:scale-[1.04] shadow-[0_10px_28px_rgba(63,166,109,0.3)]"
          >
            Jetzt gratis bestellen
          </button>
          <button
            data-testid="hero-cta-secondary"
            onClick={() => scrollTo("#ablauf")}
            className="inline-flex items-center justify-center px-8 py-4 rounded-full glass text-[#1A1A1F] font-medium text-base hover:bg-white transition-colors"
          >
            So funktioniert's
          </button>
        </div>

        <div className="mt-14 flex flex-wrap items-center justify-center gap-3">
          {trustItems.map(({ icon: Icon, label }) => (
            <div
              key={label}
              data-testid={`hero-trust-${label}`}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass text-sm text-[#1A1A1F]/85"
            >
              <Icon size={16} className="text-[#3FA66D]" />
              {label}
            </div>
          ))}
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 inset-x-0 h-24 bg-gradient-to-b from-transparent to-[#FAFAF7]" />
    </section>
  );
};

export default Hero;
